import { Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../helper/validtors-helper';

export const Validation = {
  clinic: {
    NAME: {
      pattren: [
        noWhitespaceValidator,
        Validators.required,
        Validators.pattern('^[a-zA-Z ]+$'),
      ],
      isRequired: true,
    },
    EMAIL: {
      pattren: [noWhitespaceValidator, Validators.required, Validators.email],
      isRequired: true,
    },
    PHONE: {
      pattren: [
        noWhitespaceValidator,
        Validators.required,
        Validators.pattern(/^\+?[0-9\s\-()]{7,20}$/),
      ],
      isRequired: true,
    },
    LANGUAGE: {
      pattren: [noWhitespaceValidator, Validators.required],
      isRequired: true,
    },
    ADDRESS: {
      pattren: [noWhitespaceValidator, Validators.required],
      isRequired: true,
    },
    FAX: {
      pattren: [
        noWhitespaceValidator,
        Validators.required,
        Validators.pattern(/^\+?[0-9\s\-()]{7,20}$/),
      ],
      isRequired: true,
    },
    TIMEZONE: {
      pattren: [noWhitespaceValidator, Validators.required],
      isRequired: true,
    },
    PROGRAM: {
      pattren: [noWhitespaceValidator, Validators.required],
      isRequired: true,
    },
    TWILIO: {
      pattren: [
        noWhitespaceValidator,
        Validators.required,
        Validators.pattern(/^\+?[1-9]\d{1,14}$/),
      ],
      isRequired: true,
    },
    CLINICSTATE: {
      pattren: [noWhitespaceValidator, Validators.required],
      isRequired: true,
    },
  },
};
